import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 7c0-.55.45-1 1-1s1 .45 1 1v15c0 .55-.45 1-1 1s-1-.45-1-1v-6.5H6V22c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v6.5h11zM24 26h6v-.01c.55 0 1-.45 1-1s-.45-1-1-1h-4l4.32-5.76c.46-.66.69-1.44.69-2.24a4.08 4.08 0 0 0-.91-2.53 4 4 0 0 0-2.3-1.38c-.9-.18-1.85-.05-2.66.38-.82.43-1.46 1.13-1.82 1.98-.22.51.02 1.09.53 1.31.5.21 1.1-.02 1.31-.53.18-.42.5-.78.91-.99s.88-.28 1.33-.19.86.33 1.15.69.45.81.45 1.27c.01.4-.11.78-.31 1.07L23.2 24.4c-.22.31-.26.71-.09 1.05s.51.55.89.55"
    />
  </svg>
);
const SvgIconTextHTwo = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextHTwo);
export default Memo;
